import { render } from "./DashboardActionPanel.vue?vue&type=template&id=119b9d11"
import script from "./DashboardActionPanel.vue?vue&type=script&lang=js"
export * from "./DashboardActionPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__